
import HitAreaSelection from './HitAreaSelection'
import LevelSelection from './LevelSelection'
import UnitSelection from './UnitSelection'

const MapSelection = {

  select(selector, mapModel) {
    switch(selector) {
      case 'levels': return new LevelSelection(mapModel.get('levels'), mapModel)
      case 'hitareas': return new HitAreaSelection(mapModel.get('hitareas'))
      case 'units': return new UnitSelection(mapModel.get('units'))
      default:
        throw new Error(`"${selector}" is not a valid selector.`)
    }
  }
}

export default MapSelection
